// extracted by mini-css-extract-plugin
export default {"lds-spinner":"Spinner_lds-spinner__jUsae"};